<script lang="ts">

  import { Button } from "$lib/components/ui/button"
  import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
  } from "$lib/components/ui/dialog"
  import { Label } from "$lib/components/ui/label"
  import { Separator } from "$lib/components/ui/separator"
  import CopyIcon from "@lucide/svelte/icons/copy"
  import ExternalLinkIcon from "@lucide/svelte/icons/external-link"
  import { toast } from "svelte-sonner"
  import type { CustomerNoo } from "../_types"

  let {
    open,
    setOpen,
    select,
  }: {
    open: boolean
    setOpen: (open: boolean) => void
    select: CustomerNoo
  } = $props()

  async function copyCoordinate() {
    await navigator.clipboard.writeText(`${select.coordinate.latitude},${select.coordinate.longitude}`)
    toast.info("Koordinat berhasil disalin")
  }

  function handleCoordinate() {
    if (!select) return
    window.open(
      `https://maps.google.com/maps/search/?api=1&query=${select.coordinate.latitude},${select.coordinate.longitude}`,
      "_blank",
    )
  }

</script>

<Dialog
  open={open}
  onOpenChange={setOpen}>
  <DialogContent
    class="w-sm"
    onOpenAutoFocus={(event) => event.preventDefault()}>
    <DialogHeader>
      <DialogTitle>Detail</DialogTitle>
      <DialogDescription></DialogDescription>
    </DialogHeader>
    <div class="space-y-3">
      <div class="grid grid-cols-2 gap-3">
        <div>
          <Label>Nomor</Label>
          <div class="text-desc font-mono">{select.number || "-"}</div>
        </div>
        <div>
          <Label>Tanggal</Label>
          <div class="text-desc font-mono">{select.datetime.toDateFormat("dd/MM/yyyy")}</div>
        </div>
      </div>
      <div>
        <Label>Nama</Label>
        <div class="text-desc">{select.name || "-"}</div>
      </div>
      <div>
        <Label>Kategori</Label>
        <div class="text-desc">{select.category.name || "-"}</div>
      </div>
      <div class="grid grid-cols-2 gap-3">
        <div>
          <Label>BP Group</Label>
          <div class="text-desc">{select.bp_group.name || "-"}</div>
        </div>
        <div>
          <Label>BP Class</Label>
          <div class="text-desc">{select.bp_class.name || "-"}</div>
        </div>
      </div>
      <div>
        <Label>Opsi Pengiriman</Label>
        <div class="text-desc">{select.delivery.name || "-"}</div>
      </div>
      <div class="grid grid-cols-2 gap-3">
        <div>
          <Label>Kredit Limit</Label>
          <div class="text-desc font-mono">{select.payment_limit.toLocaleString("en-US")}</div>
        </div>
        <div>
          <Label>Payment Term</Label>
          <div class="text-desc">{select.payment_term.name || "-"}</div>
        </div>
      </div>
      <Separator/>
      <div>
        <Label>Nama Pajak</Label>
        <div class="text-desc">{select.tax_name || "-"}</div>
      </div>
      <div>
        <Label>NPWP</Label>
        <div class="text-desc font-mono">{select.tax_number || "-"}</div>
      </div>
      <div>
        <Label>Nama</Label>
        <div class="text-desc">{select.contact_name || "-"}</div>
      </div>
      <div>
        <Label>Telepon</Label>
        <div class="text-desc font-mono">{select.contact_phone || "-"}</div>
      </div>
      <div class="grid grid-cols-2 gap-3">
        <div>
          <Label>Provinsi</Label>
          <div class="text-desc">{select.province.name || "-"}</div>
        </div>
        <div>
          <Label>Kota</Label>
          <div class="text-desc">{select.city.name || "-"}</div>
        </div>
      </div>
      <div>
        <Label>Alamat</Label>
        <div class="text-desc">{select.address || "-"}</div>
      </div>
      <div class="space-y-1">
        <Label>Koordinat</Label>
        <div class="font-mono text-xs">
          {select.coordinate.latitude},{select.coordinate.longitude}
        </div>
        <div class="flex gap-2">
          <Button
            variant="outline"
            size="icon-sm"
            aria-label="Salin koordinat"
            disabled={!select.coordinate.latitude && !select.coordinate.longitude}
            onclick={copyCoordinate}>
            <CopyIcon aria-hidden="true"/>
          </Button>
          <Button
            variant="outline"
            size="icon-sm"
            aria-label="Buka koordinat di peta"
            disabled={!select.coordinate.latitude && !select.coordinate.longitude}
            onclick={handleCoordinate}>
            <ExternalLinkIcon aria-hidden="true"/>
          </Button>
        </div>
      </div>
      <div>
        <Label>Radius</Label>
        <div class="text-desc font-mono">{select.radius || 0}M</div>
      </div>
    </div>
  </DialogContent>
</Dialog>
